module.exports = __webpack_public_path__ + "static/media/interactive-virtual.d7204041.png";